import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=22447f44&scoped=true&"
import script from "./searchResult.vue?vue&type=script&lang=js&"
export * from "./searchResult.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./searchResult.vue?vue&type=style&index=0&id=22447f44&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "22447f44",
  "23f189fd"
  
)

export default component.exports